import React from 'react'

function RichText({ html, className }: { html: string; className?: string }) {
	return <div className={`user-rich-text ${className || ''}`} dangerouslySetInnerHTML={{ __html: html }} />
}

export default RichText
